import React, { useState } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import { StoreDetailPanel } from './StoreDetailPanel';
import { MapLegend } from './MapLegend';
import { storesData } from '../../data/stores';
const statusColors = {
  success: '#22c55e',
  warning: '#eab308',
  danger: '#ef4444'
};
// Deterministic score based on store id
function generateScore(id: number): number {
  const seed = (id * 2654435761 >>> 0) % 1000;
  return Math.round((3.0 + seed / 1000 * 2.0) * 10) / 10; // 3.0 - 5.0
}
function getStatus(score: number): string {
  if (score >= 4.3) return 'success';
  if (score >= 3.5) return 'warning';
  return 'danger';
}
// Transform JSON data to map format
const stores = storesData.map((store: any) => {
  const score = generateScore(store.id);
  return {
    id: store.id,
    name: `${store.name} ${store.city}`,
    lat: store.lat,
    lng: store.lng,
    score,
    status: getStatus(score),
    type: 'ALDI Nord Markt',
    address: `${store.streetAndNumber}, ${store.zip} ${store.city}`,
    city: store.city,
    province: store.province,
    identifier: store.identifier,
    zip: store.zip,
    streetAndNumber: store.streetAndNumber
  };
});
export { stores };
export function StoreMap() {
  const [selectedStore, setSelectedStore] = useState<any>(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const handleMarkerClick = (store: any) => {
    setSelectedStore(store);
    setIsPanelOpen(true);
  };
  return <div className="relative w-full h-full bg-gray-100 overflow-hidden" data-id="element-217">
      <MapContainer center={[52.0, 10.5]} zoom={6} style={{
      height: '100%',
      width: '100%'
    }} zoomControl={true} data-id="element-218">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-219" />
        {stores.map(store => <CircleMarker key={store.id} center={[store.lat, store.lng]} radius={6} pathOptions={{
        fillColor: statusColors[store.status as keyof typeof statusColors],
        fillOpacity: 0.9,
        color: '#ffffff',
        weight: 3
      }} eventHandlers={{
        click: () => handleMarkerClick(store)
      }} data-id="element-220">
            <Popup data-id="element-221">
              <div className="text-sm" data-id="element-222">
                <strong data-id="element-223">{store.name}</strong>
                <br data-id="element-224" />
                {store.address}
                <br data-id="element-225" />
                Bewertung: {store.score} ⭐
              </div>
            </Popup>
          </CircleMarker>)}
      </MapContainer>
      <MapLegend data-id="element-226" />
      <StoreDetailPanel isOpen={isPanelOpen} onClose={() => setIsPanelOpen(false)} store={selectedStore} data-id="element-227" />
    </div>;
}